import ForgotEmailContainer from "./ForgotEmailContainer";

export default ForgotEmailContainer;
